<!-- Icon mit Anzahl der Benachrichtigungen -->
<div class="cw-global-header-icon" (click)="toggleNotifications()">
  <span class="cw-global-notification-icon icon-bell" [ngClass]="{jiggleIcon: doUnreadNotificationsExist}"></span>
  <span matBadgeColor="accent" [matBadge]="countNotifications" class="matBadgePosition"></span>
</div>

<!-- Benachrichtigungen -->
@if (showNotifications) {
  <mat-card appearance="outlined">
    <div class="cw-flex-row shadow">
      <h2 class="cw-notification-header">
        {{ countNotifications }}
        {{
        countNotifications === 1 ? ('GENERAL.NOTIFICATION' | translate) : ('GENERAL.NOTIFICATIONS' | translate)
        }}
      </h2>
      <div class="cw-toolbar">
        @if (countNotifications > 0) {
          <button
            mat-raised-button
            color="primary"
            type="button"
            (click)="markAllRead()"
            class="marginLeftTenPx">
            {{ 'GLOBAL.NOTIFICATIONS.MARKALLREAD' | translate }}
          </button>
        }
        <span class="icon-close cw-toolbar-icon" (click)="toggleNotifications()"></span>
      </div>
    </div>
    <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
    @if (!loading) {
      <mat-list>
        @for (item of data; track item; let i = $index) {
          <div class="cw-flex-row global-notification-row">
            <phscw-input-single-checkbox
              matTooltip="{{ 'GLOBAL.NOTIFICATIONS.MARKREAD' | translate }}"
              matTooltipPosition="left"
              [editMode]="true"
              inputId="notifications-checkbox"
              name="notifications-checkbox"
              [showOptionLabel]="false"
              (ngModelChange)="onCheckboxChange($event, item.id, i)"
              [(ngModel)]="$any(item).strikeout"
              class="global-notification-checkbox">
            </phscw-input-single-checkbox>
            <div
              class="clickable-wrapper global-notification-wrapper"
              (click)="navigateTo($any(item).navigation)"
              matTooltip="{{ $any(item).navigation ? 'Wechsel zur Entität' : 'Wechsel nicht implementiert' }}">
              @if (findFittingIcon(item.notification_type); as fittingIcon) {
                <fa-icon
                  [icon]="fittingIcon"
                  class="cw-toolbar-icon global-notification-icon"
                  [ngClass]="{disableclick: !$any(item).navigation}">
                </fa-icon>
              }
              <span [ngClass]="{strikethrough: $any(item).strikeout}">
                <mat-list-item
                  class="notification-fix global-notification-item"
                  [innerHTML]="item.notification">
                </mat-list-item>
              </span>
            </div>
          </div>
        }
      </mat-list>
    }
  </mat-card>
}
